import moment from 'moment';
import { isBoolean, isNumber, toNumber } from 'lodash';

const dateStoreFormat = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
//判断是否是直播任务
const isStreamingQuest = quest =>
    quest && quest.type && (quest.type === 'tiered' || quest.type === 'tiered-one-time' || quest.type === 'tiered-multi-days');
//判断是否是自动直播任务
const isAutoStreamQuest = quest =>
    quest && quest.type && (quest.type === 'tiered-auto');
//判断是否是二创任务
const isSecondaryCreationQuest = quest =>
    quest && quest.type && (quest.type === 'secondary-creation');
//判断是否是新类型任务
const isNewTypeQuest = quest =>
    quest && quest.type && (quest.type === 'tiered-auto' || quest.type === 'secondary-creation');

const getQuestTypeFlagsFromValues = (values = {}) => {
    const streamingQuest = isStreamingQuest(values);
    const autoStreamingQuest = isAutoStreamQuest(values);
    const secondaryCreationQuest = isSecondaryCreationQuest(values);
    const newTypeQuest = isNewTypeQuest(values);
    // 判断是否是新类型任务
    const streamOrNewTypeQuest = autoStreamingQuest || secondaryCreationQuest || streamingQuest;
    return {
        streamingQuest,
        autoStreamingQuest,
        secondaryCreationQuest,
        newTypeQuest,
        streamOrNewTypeQuest,
    };
};


export const validateQuestForm = (values, props) => {
    const errors = {};

    const {
        streamingQuest,
        autoStreamingQuest,
        secondaryCreationQuest,
        newTypeQuest,
    } = getQuestTypeFlagsFromValues(values);

    if (!isBoolean(values.isPrivate)) {
        errors.isPrivate = 'This field is required';
    }

    if (streamingQuest && !isBoolean(values.twitchAccountRequired) && !values.isPrivate) {
        errors.twitchAccountRequired = 'This field is required';
    }

    if (streamingQuest && !values.twitchAccountRequired && values.requirePreapproval && !values.isPrivate) {
        errors.twitchAccountRequired = 'Twitch account required for preapproval quests';
    }

    if (newTypeQuest && (!values.miniFollowers || values.miniFollowers === '')) {
        errors.miniFollowers = 'This field is required';
    } else if (newTypeQuest && values.miniFollowers <= 0) {
        errors.miniFollowers = 'This field must be above 0';
    } else if (!/^\d+$/.test(values.miniFollowers)) {
        errors.miniFollowers = 'This field must be an integer.';
    }

    if (!values.type || values.type.trim() === '') {
        errors.type = 'This field is required';
    }

    if (!values.title || values.title.trim() === '') {
        errors.title = 'This field is required';
    }

    if (!values.status || values.status.trim() === '') {
        errors.status = 'This field is required';
    }

    console.log('验证时间字段:', {
        startDateTime: values.startDateTime,
        endDateTime: values.endDateTime,
        openRegistrationDate: values.openRegistrationDate,
        closeRegistrationDate: values.closeRegistrationDate,
    });

    // 支持ISO格式和自定义格式的日期验证
    const isValidStartDate = moment(values.startDateTime, moment.ISO_8601, true).isValid()
        || moment(values.startDateTime, dateStoreFormat, true).isValid();

    const isValidEndDate = moment(values.endDateTime, moment.ISO_8601, true).isValid()
        || moment(values.endDateTime, dateStoreFormat, true).isValid();

    if (!values.startDateTime) {
        errors.startDateTime = 'This field is required';
    } else if (!isValidStartDate) {
        errors.startDateTime = `This date is not valid`;
    }

    if (!values.endDateTime) {
        errors.endDateTime = 'This field is required';
    } else if (!isValidEndDate) {
        errors.endDateTime = `This date is not valid`;
    }

    // 支持ISO格式和自定义格式的日期验证
    const isValidOpenRegistrationDate = moment(values.openRegistrationDate, moment.ISO_8601, true).isValid()
        || moment(values.openRegistrationDate, dateStoreFormat, true).isValid();

    const isValidCloseRegistrationDate = moment(values.closeRegistrationDate, moment.ISO_8601, true).isValid()
        || moment(values.closeRegistrationDate, dateStoreFormat, true).isValid();

    if (!values.openRegistrationDate) {
        errors.openRegistrationDate = 'This field is required';
    } else if (!isValidOpenRegistrationDate) {
        errors.openRegistrationDate = `This date is not valid`;
    }

    if (!values.closeRegistrationDate) {
        errors.closeRegistrationDate = 'This field is required';
    } else if (!isValidCloseRegistrationDate) {
        errors.closeRegistrationDate = `This date is not valid`;
    }

    if (values.type === 'referral' && !values.referralPaymentType) {
        errors.referralPaymentType = 'This field is required';
    }

    if (values.type === 'referral' && values.referralPaymentType && values.referralPaymentType === 'commission-amount' && !values.commissionAmount) {
        errors.commissionAmount = 'This field is required';
    }

    if (values.type === 'referral' && values.referralPaymentType && values.referralPaymentType === 'commission-percentage' && !values.commissionPercentage) {
        errors.commissionPercentage = 'This field is required';
    }

    if (values.type === 'referral' && values.referralPaymentType && values.referralPaymentType === 'commission-amount' && !/^\d+(.\d{1,2})?$/i.test(values.commissionAmount)) {
        errors.commissionAmount = 'Incorrect format';
    }

    if (values.type === 'referral' && values.referralPaymentType && values.referralPaymentType === 'commission-percentage' && !/^[1-9][0-9]?$|^100$/i.test(values.commissionPercentage)) {
        errors.commissionPercentage = 'Incorrect format';
    }

    if (values.type === 'timed' && (!values.requiredStreamTimeMinutes || !isNumber(toNumber(values.requiredStreamTimeMinutes)) || values.requiredStreamTimeMinutes <= 0)) {
        errors.requiredStreamTimeMinutes = 'Required';
    }

    if (values.type === 'timed' && (values.requiredStreamTimeMinutes <= 0)) {
        errors.requiredStreamTimeMinutes = 'gte than 0';
    }

    if (values.type === 'tiered-one-time' || values.type === 'tiered-multi-days' || values.type === 'paid bounty' || values.type === 'timed') {
        const requiredStreamTimeMinutes = toNumber(values.requiredStreamTimeMinutes);
        if (Number.isNaN(requiredStreamTimeMinutes)) {
            errors.requiredStreamTimeMinutes = 'This field is not a number';
        }
        if (isNumber(requiredStreamTimeMinutes) && requiredStreamTimeMinutes <= 0) {
            errors.requiredStreamTimeMinutes = 'This field must be greater than 0';
        }
    }

    if (values.type !== 'basic' && (!values.requiredStreamTimeMinutes || !isNumber(toNumber(values.requiredStreamTimeMinutes)))) {
        errors.requiredStreamTimeMinutes = 'This field is required';
    }

    if (values.isReferral === true && values.referralBonus === true && !values.salesForBonus > 0) {
        errors.salesForBonus = 'Required';
    }

    if (values.isReferral === true && values.referralBonus === true && !values.bonusValue > 0) {
        errors.bonusValue = 'Required';
    }

    if (values.isReferral === true && values.referralBonus === true && (values.referralBonusType !== 'bonus-in-percentage' && values.referralBonusType !== 'bonus-in-amount')) {
        errors.referralBonusType = 'Required';
    }

    if (values.isReferral === true && values.referralBonus === true && (values.referralBonusTimes !== 'once' && values.referralBonusTimes !== 'every-sale')) {
        errors.referralBonusTimes = 'Required';
    }

    if (!values.slug || values.slug.trim() === '') {
        errors.slug = 'This field is required';
    }

    if (values.type === 'timed' && (values.paymentAmount < 0 || !isNumber(toNumber(values.paymentAmount)))) {
        errors.paymentAmount = 'This field is required';
    }

    if (values.type === 'paid bounty' && (values.dailyEarning < 0 || !isNumber(toNumber(values.dailyEarning)))) {
        errors.dailyEarning = 'This field is required';
    }

    if (values.type === 'basic' && !values?.viewerTiers?.length) {
        errors.viewerTiers = 'This field is required';
    }

    if (values.viewerTiers && values.viewerTiers.length > 0) {
        const viewerTiersArrayErrors = [];
        values.viewerTiers.forEach((viewerTier, index) => {
            const viewerTierErrors = {};

            let isErroring = false;

            if ((!viewerTier.paymentAmount && viewerTier.paymentAmount !== 0) || viewerTier.paymentAmount === '') {
                viewerTierErrors.paymentAmount = 'This field is required';
                isErroring = true;
            } else {
                const paymentAmount = toNumber(viewerTier.paymentAmount);
                if (Number.isNaN(paymentAmount)) {
                    viewerTierErrors.paymentAmount = 'This field is not a number';
                    isErroring = true;
                }
            }

            if ((!viewerTier.minimumAverageViewers && viewerTier.minimumAverageViewers !== 0) || viewerTier.minimumAverageViewers === '') {
                viewerTierErrors.minimumAverageViewers = 'This field is required';
                isErroring = true;
            } else {
                const minimumAverageViewers = toNumber(viewerTier.minimumAverageViewers);
                if (Number.isNaN(minimumAverageViewers)) {
                    viewerTierErrors.minimumAverageViewers = 'This field is not a number';
                    isErroring = true;
                }
            }

            if (!viewerTier.spotsAvailable || viewerTier.spotsAvailable === '') {
                viewerTierErrors.spotsAvailable = 'This field is required';
                isErroring = true;
            } else {
                const spotsAvailable = toNumber(viewerTier.spotsAvailable);
                if (Number.isNaN(spotsAvailable)) {
                    viewerTierErrors.spotsAvailable = 'This field is not a number';
                    isErroring = true;
                }
            }

            if (isErroring) viewerTiersArrayErrors[index] = viewerTierErrors;
        });

        if (viewerTiersArrayErrors.length) {
            errors.viewerTiers = viewerTiersArrayErrors;
        }
    }

    if (values.memberTiers && values.memberTiers.length > 0) {
        const memberTiersArrayErrors = [];
        values.memberTiers.forEach(({ paymentAmount, identity, type }, index) => {
            const memberTierErrors = {};
            const mtPaymentAmount = toNumber(paymentAmount);
            let isErroring = false;

            if (Number.isNaN(mtPaymentAmount) || mtPaymentAmount === '' || !mtPaymentAmount) {
                memberTierErrors.paymentAmount = 'This field is not a number';
                isErroring = true;
            }

            if (isNumber(mtPaymentAmount) && mtPaymentAmount <= 0) {
                memberTierErrors.paymentAmount = 'This field must be greater than 0';
                isErroring = true;
            }

            if (!identity || identity.trim() === '') {
                memberTierErrors.identity = 'This field is required';
                isErroring = true;
            }
            if (!type || type.trim() === '' || type.trim() === 'Select type') {
                memberTierErrors.type = 'This field is required';
                isErroring = true;
            }

            if (isErroring) memberTiersArrayErrors[index] = memberTierErrors;
        });

        if (memberTiersArrayErrors.length) {
            errors.memberTiers = memberTiersArrayErrors;
        }
    }

    if (values.splitTiers && values.splitTiers.length > 0) {
        const splitFiltersArrayErrors = [];

        if (autoStreamingQuest) {
            //走自动审核流程
            values.splitTiers.forEach(({ streamDays, streamHours, maxRevenue, prizePool }, index) => {
                const splitFiltersErrors = {};
                let isErroring = false;

                if (streamDays === '' || !streamDays) {
                    splitFiltersErrors.streamDays = 'This field is required';
                    isErroring = true;
                } else if (streamDays <= 0) {
                    splitFiltersErrors.streamDays = 'This field must be greater than 0';
                    isErroring = true;
                } else if (streamDays > 9999) {
                    splitFiltersErrors.streamDays = 'This field must be less than 10000';
                    isErroring = true;
                }

                if (streamHours === '' || !streamHours) {
                    splitFiltersErrors.streamHours = 'This field is required';
                    isErroring = true;
                } else if (streamHours <= 0) {
                    splitFiltersErrors.streamHours = 'This field must be greater than 0';
                    isErroring = true;
                } else if (streamHours > 9999) {
                    splitFiltersErrors.streamHours = 'This field must be less than 10000';
                    isErroring = true;
                }

                if (maxRevenue === '' || !maxRevenue) {
                    splitFiltersErrors.maxRevenue = 'This field is required';
                    isErroring = true;
                } else if (maxRevenue <= 0) {
                    splitFiltersErrors.maxRevenue = 'This field must be greater than 0';
                    isErroring = true;
                } else if (maxRevenue > 99999999) {
                    splitFiltersErrors.maxRevenue = 'This field must be less than 100000000';
                    isErroring = true;
                }

                if (prizePool === '' || !prizePool) {
                    splitFiltersErrors.prizePool = 'This field is required';
                    isErroring = true;
                } else if (prizePool > 99999999) {
                    splitFiltersErrors.prizePool = 'This field must be less than 100000000';
                    isErroring = true;
                }

                if (isErroring) splitFiltersArrayErrors[index] = splitFiltersErrors;
            });
        }

        if (secondaryCreationQuest) {
            //走二创流程
            values.splitTiers.forEach(({ totalUploadDays, validUploadCount, totalViews, maxRevenue, prizePool }, index) => {
                const splitFiltersErrors = {};
                let isErroring = false;

                // Check if all three requirements are zero or empty
                const allZeroOrEmpty =
                    (!totalUploadDays || Number(totalUploadDays) === 0) &&
                    (!validUploadCount || Number(validUploadCount) === 0) &&
                    (!totalViews || Number(totalViews) === 0);

                if (allZeroOrEmpty) {
                    splitFiltersErrors.totalUploadDays = 'At least one requirement must be greater than 0';
                    splitFiltersErrors.validUploadCount = 'At least one requirement must be greater than 0';
                    splitFiltersErrors.totalViews = 'At least one requirement must be greater than 0';
                    isErroring = true;
                } else {
                    // Only check range if not empty
                    if (totalUploadDays !== '' && totalUploadDays != null) {
                        if (Number(totalUploadDays) < 0) {
                            splitFiltersErrors.totalUploadDays = 'This field cannot be less than 0';
                            isErroring = true;
                        } else if (!/^\d+$/.test(totalUploadDays)) {
                            splitFiltersErrors.totalUploadDays = 'This field must be an integer.';
                            isErroring = true;
                        } else if (Number(totalUploadDays) > 999) {
                            splitFiltersErrors.totalUploadDays = 'This field must be less than 1000';
                            isErroring = true;
                        }
                    }
                    if (validUploadCount !== '' && validUploadCount != null) {
                        if (Number(validUploadCount) < 0) {
                            splitFiltersErrors.validUploadCount = 'This field cannot be less than 0';
                            isErroring = true;
                        } else if (!/^\d+$/.test(validUploadCount)) {
                            splitFiltersErrors.validUploadCount = 'This field must be an integer.';
                            isErroring = true;
                        } else if (Number(validUploadCount) > 9999) {
                            splitFiltersErrors.validUploadCount = 'This field must be less than 10000';
                            isErroring = true;
                        }
                    }
                    if (totalViews !== '' && totalViews != null) {
                        if (Number(totalViews) < 0) {
                            splitFiltersErrors.totalViews = 'This field cannot be less than 0';
                            isErroring = true;
                        } else if (!/^\d+$/.test(totalViews)) {
                            splitFiltersErrors.totalViews = 'This field must be an integer.';
                            isErroring = true;
                        } else if (Number(totalViews) > 99999999) {
                            splitFiltersErrors.totalViews = 'This field must be less than 100000000';
                            isErroring = true;
                        }
                    }
                }

                // maxRevenue and prizePool must still be greater than 0
                if (maxRevenue === '' || !maxRevenue) {
                    splitFiltersErrors.maxRevenue = 'This field is required';
                    isErroring = true;
                } else if (maxRevenue <= 0) {
                    splitFiltersErrors.maxRevenue = 'This field must be greater than 0';
                    isErroring = true;
                } else if (maxRevenue > 99999999) {
                    splitFiltersErrors.maxRevenue = 'This field must be less than 100000000';
                    isErroring = true;
                }

                if (prizePool === '' || !prizePool) {
                    splitFiltersErrors.prizePool = 'This field is required';
                    isErroring = true;
                } else if (prizePool <= 0) {
                    splitFiltersErrors.prizePool = 'This field must be greater than 0';
                    isErroring = true;
                } else if (prizePool > 99999999) {
                    splitFiltersErrors.prizePool = 'This field must be less than 100000000';
                    isErroring = true;
                }

                if (isErroring) splitFiltersArrayErrors[index] = splitFiltersErrors;
            });
        }

        if (splitFiltersArrayErrors.length) {
            errors.splitTiers = splitFiltersArrayErrors;
        }
    }

    if (values.rankTiers && values.rankTiers.length > 0) {
        console.log(12313)
        console.log("secondaryCreationQuest", secondaryCreationQuest)
        const rankTiersArrayErrors = [];

        if (autoStreamingQuest) {
            values.rankTiers.forEach(({ rankUpper, rankLower, watchTime, prize }, index) => {
                const errorsForTier = {};
                let hasBasicError = false;

                // 基础必填校验：不能为空且大于0
                if (rankUpper == null || rankUpper === '' || toNumber(rankUpper) <= 0) {
                    errorsForTier.rankUpper = 'This field is required and must be greater than 0';
                    hasBasicError = true;
                } else if (toNumber(rankLower) > 999) {
                    errorsForTier.rankLower = 'This field  must be less than 1000';
                    hasBasicError = true;
                }
                if (rankLower == null || rankLower === '' || toNumber(rankLower) <= 0) {
                    errorsForTier.rankLower = 'This field is required and must be greater than 0';
                    hasBasicError = true;
                } else if (toNumber(rankLower) > 9999) {
                    errorsForTier.rankLower = 'This field  must be less than 10000';
                    hasBasicError = true;
                }
                if (watchTime == null || watchTime === '' || toNumber(watchTime) <= 0) {
                    errorsForTier.watchTime = 'This field is required and must be greater than 0';
                    hasBasicError = true;
                } else if (toNumber(watchTime) > 99999999) {
                    errorsForTier.watchTime = 'This field  must be less than 100000000';
                    hasBasicError = true;
                }
                if (prize == null || prize === '' || toNumber(prize) <= 0) {
                    errorsForTier.prize = 'This field is required and must be greater than 0';
                    hasBasicError = true;
                } else if (toNumber(prize) > 99999999) {
                    errorsForTier.prize = 'This field  must be less than 100000000';
                    hasBasicError = true;
                }

                // 如果基础验证都通过，再进行 index > 0 时的交叉规则验证
                if (!hasBasicError) {
                    console.log("Rank Lower must be greater than or equal to Rank Upper")
                    // ============ 排名逻辑校验 ============ //
                    if (toNumber(rankLower) < toNumber(rankUpper)) {
                        errorsForTier.rankLower = 'Rank Lower must be greater than  Rank Upper';
                    }

                    // 第一行必须从 1 开始
                    if (index === 0 && toNumber(rankUpper) !== 1) {
                        errorsForTier.rankUpper = 'First tier must have Rank Upper as 1';
                    }

                    // 当前行与前一行连续4
                    if (index > 0) {
                        const prevTier = values.rankTiers[index - 1];
                        if (toNumber(rankUpper) !== toNumber(prevTier.rankLower) + 1) {
                            errorsForTier.rankUpper = `Rank Upper must be ${toNumber(prevTier.rankLower) + 1}`;
                        }
                    }

                }

                if (Object.keys(errorsForTier).length > 0) {
                    rankTiersArrayErrors[index] = errorsForTier;
                }
            });
        }

        if (secondaryCreationQuest) {
            values.rankTiers.forEach(
                ({ rankUpper, rankLower, minTotalViews, prize }, index) => {
                    console.log(index, rankUpper, rankLower, minTotalViews, prize)


                    const errorsForTier = {};
                    let hasBasicError = false;
                    console.log("hasBasicError", hasBasicError)

                    // ============ 基础校验 ============ //
                    if (rankUpper == null || rankUpper === '' || toNumber(rankUpper) <= 0) {
                        errorsForTier.rankUpper = 'This field is required and must be greater than 0';
                        hasBasicError = true;
                    } else if (!/^\d+$/.test(rankUpper)) {
                        errorsForTier.rankUpper = 'This field must be an integer.';
                        hasBasicError = true;
                    } else if (Number(rankUpper) > 999) {
                        errorsForTier.rankUpper = 'This field must be less than 10000';
                        hasBasicError = true;
                    }

                    if (rankLower == null || rankLower === '' || toNumber(rankLower) <= 0) {
                        errorsForTier.rankLower = 'This field is required and must be greater than 0';
                        hasBasicError = true;
                    } else if (!/^\d+$/.test(rankLower)) {
                        errorsForTier.rankLower = 'This field must be an integer.';
                        hasBasicError = true;
                    } else if (Number(rankLower) > 9999) {
                        errorsForTier.rankLower = 'This field must be less than 10000';
                        hasBasicError = true;
                    }

                    if (minTotalViews == null || minTotalViews === '' || toNumber(minTotalViews) <= 0) {
                        errorsForTier.minTotalViews = 'This field is required and must be greater than 0';
                        hasBasicError = true;
                    } else if (!/^\d+$/.test(minTotalViews)) {
                        errorsForTier.minTotalViews = 'This field must be an integer.';
                        hasBasicError = true;
                    } else if (Number(minTotalViews) > 99999999) {
                        errorsForTier.minTotalViews = 'This field must be less than 10000';
                        hasBasicError = true;
                    }

                    if (prize == null || prize === '' || toNumber(prize) <= 0) {
                        errorsForTier.prize = 'This field is required and must be greater than 0';
                        hasBasicError = true;
                    }

                    if (!hasBasicError) {
                        console.log("Rank Lower must be greater than or equal to Rank Upper")
                        // ============ 排名逻辑校验 ============ //
                        if (toNumber(rankLower) < toNumber(rankUpper)) {
                            errorsForTier.rankLower = 'Rank Lower must be greater than  Rank Upper';
                        }

                        // 第一行必须从 1 开始
                        if (index === 0 && toNumber(rankUpper) !== 1) {
                            errorsForTier.rankUpper = 'First tier must have Rank Upper as 1';
                        }

                        // 当前行与前一行连续4
                        if (index > 0) {
                            const prevTier = values.rankTiers[index - 1];
                            if (toNumber(rankUpper) !== toNumber(prevTier.rankLower) + 1) {
                                errorsForTier.rankUpper = `Rank Upper must be ${toNumber(prevTier.rankLower) + 1}`;
                            }
                        }

                    }

                    // 有错误时添加
                    if (Object.keys(errorsForTier).length > 0) {
                        rankTiersArrayErrors[index] = errorsForTier;
                    }
                }
            );

            // 最终传给 errors 对象
            if (rankTiersArrayErrors.length) {
                errors.rankTiers = rankTiersArrayErrors;
            }
        }
    }

    if (values.stepsPage1 && values.stepsPage1.length > 0) {
        const stepsPage1ArrayErrors = [];
        values.stepsPage1.forEach(({ title }, index) => {
            const stepsPage1Errors = {};
            let isErroring = false;

            if (!title || title.trim() === '') {
                stepsPage1Errors.title = 'This field is required';
                isErroring = true;
            }

            if (isErroring) stepsPage1ArrayErrors[index] = stepsPage1Errors;
        });

        if (stepsPage1ArrayErrors.length) {
            errors.stepsPage1 = stepsPage1ArrayErrors;
        }
    }

    if (values.whitelist && values.whitelist.length > 0) {
        const whitelistArrayErrors = [];

        values.whitelist.forEach(({ type, identity }, index) => {
            const whitelistErrors = {};
            let isErroring = false;
            if (!type) {
                whitelistErrors.type = 'This field is required';
                isErroring = true;
            }

            if (!identity || identity === '') {
                whitelistErrors.identity = 'This field is required';
                isErroring = true;
            }

            if (isErroring) whitelistArrayErrors[index] = whitelistErrors;
        });

        if (whitelistArrayErrors.length) {
            errors.whitelist = whitelistArrayErrors;
        }
    }

    const requiredBanner = values.requiredBanner === undefined || values.requiredBanner.trim() === '';
    const bannerLink = values.bannerLink === undefined || values.bannerLink.trim() === '';
    if (requiredBanner || bannerLink) {
        let displayBannerReq = false;
        const questSteps = [].concat(values.steps, values.stepsPage1);
        questSteps.forEach((step) => {
            if (step && step.type === 'display-download' && step.subtype === 'banner') {
                displayBannerReq = true;
            }
        });

        if (displayBannerReq) {
            if (requiredBanner) errors.requiredBanner = 'Display Banner Step exists, this field is required';
            if (bannerLink) errors.bannerLink = 'Display Banner Step exists, this field is required';
        }
    }

    if (!values.platforms) {
        errors.platforms = 'This field is required';
    }

    if (!values.countries || values.countries.length <= 0) {
        errors.countries = 'This field is required';
    }

    if (!values.languages || values.languages.length <= 0) {
        errors.languages = 'This field is required';
    }
    console.log('验证 requirements:', values.requirements);
    if (values.requirements) {
        const steps = ['beforeStream', 'duringStream', 'afterStream'];
        const requirementErrors = {};
        let isHighErroring = false;

        steps.forEach((step) => {
            if (values.requirements[step] && values.requirements[step].length) {
                const currentStepErrors = [];

                values.requirements[step].forEach((item, index) => {
                    const reqErrors = {};
                    let isErroring = false;

                    if (!item.title || item.title.trim() === '') {
                        console.log('验证 requirements title:', item.title);
                        // 如果 title 为空或仅包含空格，则添加错误信息
                        reqErrors.title = 'This field is required';
                        isErroring = true;
                    }
                    if (item.type === "multi-video-submission") {
                        if (!item.description || item.description.trim() === '') {
                            console.log('验证 requirements description:', item.description);
                            // 如果 title 为空或仅包含空格，则添加错误信息
                            reqErrors.description = 'This field is required';
                            isErroring = true;
                        }
                        if (!item.selectPlatform || item.selectPlatform.trim() === '') {
                            console.log('验证 requirements selectPlatform:', item.selectPlatform);
                            // 如果 title 为空或仅包含空格，则添加错误信息
                            reqErrors.selectPlatform = 'This field is required';
                            isErroring = true;
                        }
                        if (!item.submittableVideoCount || item.submittableVideoCount.trim() === '' || item.submittableVideoCount <= 0) {
                            reqErrors.submittableVideoCount = 'This field is required and must be greater than 0';
                            isErroring = true;
                        } else if (!/^\d+$/.test(item.submittableVideoCount)) {
                            reqErrors.submittableVideoCount = 'This field must be an integer.';
                            isErroring = true;
                        }

                        if (!item.label || item.label.trim() === '') {
                            console.log('验证 requirements label:', item.label);
                            // 如果 title 为空或仅包含空格，则添加错误信息
                            reqErrors.label = 'This field is required';
                            isErroring = true;
                        }
                        if (!item.placeholder || item.placeholder.trim() === '') {
                            console.log('验证 requirements placeholder:', item.placeholder);
                            // 如果 title 为空或仅包含空格，则添加错误信息
                            reqErrors.placeholder = 'This field is required';
                            isErroring = true;
                        }
                    }




                    if (isErroring) {
                        currentStepErrors[index] = reqErrors;
                    }
                });

                if (currentStepErrors.length) {
                    isHighErroring = true;
                    requirementErrors[step] = currentStepErrors;
                }
            }
        });

        if (isHighErroring) {
            errors.requirements = requirementErrors;
        }
    }

    // FAQ 验证：当 FAQ 列表不为空时，question 和 answer 均不能为空
    if (values.faqs && values.faqs.length > 0) {
        const faqArrayErrors = [];

        values.faqs.forEach(({ title }, index) => {
            const faqErrors = {};
            let isErroring = false;

            if (!title) {
                faqErrors.title = 'This field is required';
                isErroring = true;
            }

            if (isErroring) faqArrayErrors[index] = faqErrors;
        });

        if (faqArrayErrors.length) {
            errors.faqs = faqArrayErrors;
        }
    }

    // Quest Description 验证：当 Quest Description长度大于0时，title 不能为空
    if (values.questDescriptions && values.questDescriptions.length > 0) {
        const questDescriptionsArrayErrors = [];

        values.questDescriptions.forEach(({ title }, index) => {
            const questDescriptionErrors = {};
            let isErroring = false;

            if (!title) {
                questDescriptionErrors.title = 'This field is required';
                isErroring = true;
            }

            if (isErroring) questDescriptionsArrayErrors[index] = questDescriptionErrors;
        });

        if (questDescriptionsArrayErrors.length) {
            errors.questDescriptions = questDescriptionsArrayErrors;
        }
    }

    return errors;
};